import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import Cookie from 'utils/cookies';
import Link from 'components/Link';
import Cookie from 'utils/cookies';
import s from './GamesCard.scss';
import GameCard from '../../../../games/components/common/GameCard/GameCard';
// import makeRequest from '../../../../../utils/makeRequest';
import InterSectionBorder from '../../../../../components_v2/common/InterSectionBorder/InterSectionBorder';
import analyticsWrapper from '../../../../../helpers/analytics/analyticsWrapper';

import InViewObserver from '../../../../../components/InViewObserver/InViewObserver';
import Morebtn from '../../../../../components_v2/mobile/Morebtn';
import Listingheader from '../ListingheaderV2';

const GamesCard = ({ sectionData, isWapView, gaCategory, widgetUsedOn }) => {
  // const userDataRef = useRef(userData);
  const ref = useRef(null);
  const grxId = Cookie?.get('_grx') || '';

  // const getUserData = () => {
  //   try {
  //     const ssoId = Cookie.get('ssoid') || Cookie.get('ssoId') || '';
  //     const grxId = Cookie.get('_grx') || '';
  //     const GAMESLISTINGAPI = `/ufs-utility/toi-games/fetch/game/listing?pc=toi&pfm=web`;
  //     const requestParams = {
  //       params: {},
  //       headers: {
  //         grxId,
  //         ssoId,
  //       },
  //     };
  //     const mWebParam = isWapView ? '&isMobile=true' : '';
  //     const url = `${UNIFIED_FEED_DOMAIN_SERVICE}${GAMESLISTINGAPI}${mWebParam}`;
  //     makeRequest.get(url, requestParams, 'skipfeedengine').then(data => {
  //       if (data?.data?.items?.length > 0) {
  //         setItems(data?.data?.items);
  //       }
  //     });
  //   } catch (error) {
  //     console.error('Failed to fetch game data', error);
  //   }
  // };

  // useEffect(
  //   () => {
  //     if (
  //       userData &&
  //       userData.isLoggedIn !== userDataRef?.current?.isLoggedIn
  //     ) {
  //       getUserData();
  //     }
  //     userDataRef.current = userData;
  //   },
  //   [userData],
  // );

  const handleMoreBtnClick = () => {
    analyticsWrapper('ga4', {
      event: 'user_click_games',
      type: gaCategory?.ga4Type,
      category: gaCategory?.ga4Category || 'N/A',
      label: `${gaCategory?.ga4Label}_explore_more` || 'N/A',
      user_grx_id: grxId,
    });
    if (gaCategory?.ga4Type2 && gaCategory?.ga4Type2 !== '') {
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: gaCategory?.ga4Type2,
        category: gaCategory?.ga4Category2 || 'N/A',
        label: 'rightgrid_explore_more',
        user_grx_id: grxId,
      });
    }
  };

  const convertStringBooleans = data => {
    if (Array.isArray(data)) {
      return data.map(convertStringBooleans);
    }
    if (typeof data === 'object' && data !== null) {
      // Convert all boolean-like string values to actual booleans
      const convertedData = Object.fromEntries(
        Object.entries(data).map(([key, value]) => [
          key,
          typeof value === 'string' && (value === 'true' || value === 'false')
            ? value === 'true'
            : convertStringBooleans(value),
        ]),
      );
      // If `gameStatus` exists and is an object, convert it into an array
      if (
        convertedData.gameStatus &&
        typeof convertedData.gameStatus === 'object' &&
        !Array.isArray(convertedData.gameStatus)
      ) {
        convertedData.gameStatus = [convertedData.gameStatus];
      }
      return convertedData;
    }
    return data;
  };

  // const settings = {
  //   arrows: true,
  //   dots: true,
  //   slidesToShow: 3.3,
  //   slidesToScroll: 1,
  //   infinite: false,
  // };

  if (!sectionData) return null;

  // const gamesListData =
  //   // eslint-disable-next-line no-nested-ternary
  //   items?.length > 0
  //     ? items
  //     : sectionData?.items?.length > 0
  //       ? convertStringBooleans(sectionData.items)
  //       : [];
  const gamesListData =
    sectionData?.items?.length > 0
      ? convertStringBooleans(sectionData.items)
      : [];
  // const calledFrom = items.length > 0 ? '' : 'ssr_homepage';
  const calledFrom = 'ssr_homepage';
  if (gamesListData?.length > 0 && Array.isArray(gamesListData)) {
    gamesListData.forEach(gameitem => {
      gameitem.gameCategoryConfigData = {};
      if (
        !gameitem.gameCategoryData ||
        typeof gameitem.gameCategoryData !== 'object'
      ) {
        gameitem.gameCategoryConfigData = {
          listingIconUrl: {
            finishImageUrl: '',
            imageUrl: '',
            pauseImageUrl: '',
          },
        };
      } else {
        const {
          // finishImageUrl,
          imageUrl,
          pauseImageUrl,
        } = gameitem.gameCategoryData;
        gameitem.gameCategoryConfigData = {
          listingIconUrl: {
            finishImageUrl: imageUrl?.trim() || '',
            imageUrl: imageUrl?.trim() || '',
            pauseImageUrl: pauseImageUrl?.trim() || imageUrl?.trim() || '',
          },
        };
      }
    });
  }

  const groupedGames = [];
  if (gamesListData?.length > 0) {
    for (let i = 0; i < gamesListData.length; i += 2) {
      groupedGames.push(gamesListData.slice(i, i + 2));
    }
  }

  return (
    <>
      <InViewObserver
        inViewCallback={() =>
          analyticsWrapper('ga4', {
            event: 'user_shown_games',
            type: gaCategory?.ga4Type || '',
            label: gaCategory?.ga4Label || '',
            user_grx_id: grxId,
          })
        }
      >
        {sectionData?.border === 'top' && (
          <InterSectionBorder border={sectionData?.border} />
        )}
        <div className={`${s.vocCardWrap} slick_UI`}>
          {!isWapView ? (
            <>
              <div className={s.title}>
                <Listingheader
                  headingname="Daily Puzzles"
                  headingLink="/games"
                  ga4Type={
                    widgetUsedOn &&
                    widgetUsedOn !== '' &&
                    widgetUsedOn === 'homepage' &&
                    gaCategory?.ga4Type2 &&
                    gaCategory?.ga4Type2 !== ''
                      ? gaCategory?.ga4Type2
                      : gaCategory?.ga4Type
                  }
                  ga4Category={
                    widgetUsedOn &&
                    widgetUsedOn !== '' &&
                    widgetUsedOn === 'homepage' &&
                    gaCategory?.ga4Category2 &&
                    gaCategory?.ga4Category2 !== ''
                      ? gaCategory?.ga4Category2
                      : 'N/A'
                  }
                  ga4Label={
                    widgetUsedOn &&
                    widgetUsedOn !== '' &&
                    widgetUsedOn === 'homepage' &&
                    gaCategory?.ga4Label2 &&
                    gaCategory?.ga4Label2 !== ''
                      ? `${gaCategory?.ga4Label2}daily_puzzles`
                      : `${gaCategory?.ga4Label}_daily_puzzles`
                  }
                  overrideClass="gamesCardRhsHeader"
                />
              </div>
              {gamesListData?.length > 0 &&
                Array.isArray(gamesListData) && (
                  <div className={s.gamesListRhs}>
                    {gamesListData.slice(0, 3).map(
                      sectionItem =>
                        sectionItem?.tn === 'gameCategory' &&
                        sectionItem?.gameCategoryData?.gameType ? (
                          <div className={s.item}>
                            <GameCard
                              key={sectionItem?.gameCategoryData?.gameType.replace(
                                /_/g,
                                '-',
                              )}
                              calledFrom={calledFrom}
                              widgetUsedOn={
                                widgetUsedOn === 'articleshow'
                                  ? 'articleshow'
                                  : 'homepage'
                              }
                              gameType={sectionItem?.gameCategoryData?.gameType.replace(
                                /_/g,
                                '-',
                              )}
                              isMobile={isWapView}
                              ga4Category={sectionItem?.gameCategoryData?.gameType.replace(
                                /_/g,
                                '-',
                              )}
                              ga4Type={gaCategory?.ga4Type}
                              ga4Type2={gaCategory?.ga4Type2 || ''}
                              ga4Category2={gaCategory?.ga4Category2 || ''}
                              ga4Label2={gaCategory?.ga4Label2 || ''}
                              data={sectionItem?.gameCategoryData}
                              gameCategoryConfigData={
                                sectionItem?.gameCategoryConfigData || {}
                              }
                              gameEntryPoint
                              gameEntryPointRhs
                            />
                          </div>
                        ) : null,
                    )}
                    <div className={s.btnWrap}>
                      <Morebtn
                        onClick={handleMoreBtnClick}
                        moreLink="/games"
                        absoluteMoreText={
                          sectionData?.moreText || 'Explore More Puzzles'
                        }
                      />
                    </div>
                  </div>
                )}
            </>
          ) : (
            <>
              {gamesListData?.length > 0 &&
                Array.isArray(gamesListData) && (
                  <>
                    {/* <div className={s.dottedLine}>
                      <div className={s.toiGameCapsule}>
                        <i className={s.iconToiGames} />
                      </div>
                    </div> */}
                    <div className={s.title}>
                      <Listingheader
                        headingname="Daily Puzzles"
                        headingLink="/games"
                        ga4Type={gaCategory?.ga4Type}
                        ga4Category={gaCategory?.ga4Category || ''}
                        ga4Label={`${gaCategory?.ga4Label}_daily_puzzles` || ''}
                        overrideClass="gamesCardHeader"
                      />
                      {/* <h2>
                        <span>Daily Puzzles</span>
                      </h2> */}
                    </div>
                    <div className={s.mobileScroll}>
                      {groupedGames.map((group, index) => (
                        <div key={index} className={s.slide}>
                          {group.map(
                            sectionItem =>
                              sectionItem?.tn === 'gameCategory' &&
                              sectionItem?.gameCategoryData?.gameType ? (
                                <GameCard
                                  key={sectionItem.gameCategoryData.gameType.replace(
                                    /_/g,
                                    '-',
                                  )}
                                  calledFrom={calledFrom}
                                  widgetUsedOn={
                                    widgetUsedOn === 'articleshow'
                                      ? 'articleshow'
                                      : 'homepage'
                                  }
                                  gameType={sectionItem.gameCategoryData.gameType.replace(
                                    /_/g,
                                    '-',
                                  )}
                                  isMobile={isWapView}
                                  ga4Category={sectionItem?.gameCategoryData?.gameType.replace(
                                    /_/g,
                                    '-',
                                  )}
                                  ga4Type={gaCategory?.ga4Type}
                                  data={sectionItem.gameCategoryData}
                                  gameCategoryConfigData={
                                    sectionItem.gameCategoryConfigData || {}
                                  }
                                  gameEntryPoint
                                />
                              ) : null,
                          )}
                        </div>
                      ))}
                    </div>
                    {/* <Morebtn
                      moreLink={sectionData?.path || '/games'}
                      absoluteMoreText={
                        sectionData?.moreText || 'Explore All Games New'
                      }
                      ga4Type="explore_all_games"
                      ga4Category={sectionData?.ga4Type || ''}
                      gaLabel="homepage"
                      userGrxId={Cookie?.get('_grx') || ''}
                    /> */}
                  </>
                )}
            </>
          )}
        </div>
        {sectionData?.border === 'bottom' && (
          <InterSectionBorder border={sectionData?.border} />
        )}
      </InViewObserver>
    </>
  );
};

const mapStateToProps = state => ({
  userData: state.login.userData,
});

GamesCard.propTypes = {
  sectionData: PropTypes.shape({
    name: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    id: PropTypes.string,
    subSections: PropTypes.shape({ dataUrl: PropTypes.string }),
  }),
  isWapView: PropTypes.bool,
  userData: PropTypes.shape({}),
  gaCategory: PropTypes.shape({
    ga4Type: PropTypes.string,
    ga4Label: PropTypes.string,
    ga4Type2: PropTypes.string,
    ga4Category2: PropTypes.string,
    ga4Label2: PropTypes.string,
  }),
  widgetUsedOn: PropTypes.string,
};

GamesCard.defaultProps = {
  sectionData: {},
  isWapView: false,
  userData: {},
  gaCategory: {},
  widgetUsedOn: '',
};

export default connect(mapStateToProps, null)(GamesCard);
